// Quantity JS
class CustomQuantity extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('.qty-input');
    this.plusBtn = this.querySelector('.button-plus');
    this.minusBtn = this.querySelector('.button-minus');

    if (!this.input || !this.plusBtn || !this.minusBtn) return;

    this.plusBtn.addEventListener('click', () => this.increment());
    this.minusBtn.addEventListener('click', () => this.decrement());
  }

  increment() {
    let value = parseInt(this.input.value) || 0;
    this.input.value = value + 1;
    this.triggerChange();
  }

  decrement() {
    let value = parseInt(this.input.value) || 0;
    let min = parseInt(this.input.getAttribute('min')) || 1;

    if (value > min) {
      this.input.value = value - 1;
      this.triggerChange();
    }
  }

  triggerChange() {
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('custom-quantity', CustomQuantity);


// Collection Filter JS
const collection = document.querySelector('.collection-content_area');
if (collection) {
  const toggler = collection.querySelector('.aside-toggler');
  const aside = collection.querySelector('aside.product-list-sidebar');

  toggler.addEventListener('click', function(e) {
      aside.classList.toggle('active');
  });
}

// Tab Container JS
class TabContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabButtons = this.querySelectorAll(".tab-button");

    tabButtons.forEach((tabButton) => {
      const handleTabInteraction = (event) => {
        event.stopPropagation();
        const currentTabContentId = tabButton.getAttribute("data-tab-content");
        const currentTitleContentId = tabButton.getAttribute("data-tab-title");
        const currentTabContent = this.querySelector(currentTabContentId);

        tabButtons.forEach((button) => {
          button.classList.remove("is-active");
        });

        tabButton.classList.add("is-active");

        this.querySelectorAll(".tab-content").forEach((tabContent) => {
          tabContent.classList.remove("is-active");
        });

        currentTabContent.classList.add("is-active");
        
      };

      tabButton.addEventListener("click", handleTabInteraction);
      tabButton.addEventListener("touchstart", handleTabInteraction);
    });

  }
}

customElements.define("tab-container", TabContainer);

// Echo Slider

(() => {
  if (!customElements.get("un-slider")) {
    class UnSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      init() {
        const slider = this.querySelector(".swiper");
        const pagination = this.querySelector(".swiper-pagination");
        const buttonNext = this.querySelector(".slider-button-next");
        const buttonPrev = this.querySelector(".slider-button-prev");

        const slideAutoPlay = this.getAttribute("data-autoplay");
        const slidesPerView = parseInt(this.getAttribute("data-slide-per-row"));
        const spaceBetweenDes = parseInt(this.getAttribute("data-space-between_des"));
        const spaceBetweenMb = parseInt(this.getAttribute("data-space-between_mb"));
        const showDots = this.getAttribute("data-show-dots");
        const showArrows = this.getAttribute("data-show-arrows");
        const tabletSlidesPerView = parseInt(this.getAttribute("data-tab-slide-per-row"));
        const mobileSlidesPerView = parseInt(this.getAttribute("data-mobile-slide-per-row"));

        const desktopMode = this.getAttribute("data-desktop-slider");
        const mobileAllowSlider = this.getAttribute("data-mobile-slider-allow");

        const swiperOptions = {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: spaceBetweenMb,
          loop: false,
          breakpoints: {
            640: {
              slidesPerView: tabletSlidesPerView,
              spaceBetween: spaceBetweenDes,
            },
            990: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetweenDes,
            },
          },
        };

        if (slideAutoPlay === "true") {
          swiperOptions.autoplay = {
            delay: 3000,
            disableOnInteraction: false,
          };
        }

        if (showDots === "true") {
          swiperOptions.pagination = {
            el: pagination,
            clickable: true,
          };
        }

        if (showArrows === "true") {
          swiperOptions.navigation = {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          };
        }

        const handleResponsiveSlider = () => {
          const isMobile = window.innerWidth < 768;
          let enableSlider = false;

          if (desktopMode === "slider") {
            enableSlider = true;
          } else if (desktopMode === "grid") {
            if (isMobile && mobileAllowSlider === "true") {
              enableSlider = true;
            }
          }

          if (enableSlider) {
            if (!this.swiper) {
              this.swiper = new Swiper(slider, swiperOptions);
              this.classList.add("is-slider-active");
              this.classList.remove("is-grid-active");
            }
          } else {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
            this.classList.add("is-grid-active");
            this.classList.remove("is-slider-active");
          }
        };

        handleResponsiveSlider();

        window.addEventListener("resize", () => {
          handleResponsiveSlider();
        });
      }

      connectedCallback() {
        this.init();
      }
    }

    customElements.define("un-slider", UnSlider);
  }
})();


